export default "__VITE_ASSET__be326e69__"